import { useEffect, useId, useState } from 'react';

import { obterHistorico } from '../api/historico';
import type { ItemDoHistorico, PaginaDoHistorico } from '../api/historico';

/** De quanto em quanto tempo o histórico pergunta ao banco se há novidade. */
const INTERVALO_MS = 5_000;

const hora = (iso: string) => new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

/**
 * O log rápido à direita de cada página de Configurações: quem alterou (AutoU ou Fiat), quando e o
 * quê, lido de `log_admin`. Relê a cada 5 s com a aba visível; falha na releitura deixa o que já
 * estava na tela.
 */
export function HistoricoDeAlteracoes({ pagina }: { pagina: PaginaDoHistorico }) {
    const idDoTitulo = useId();
    const [itens, setItens] = useState<ItemDoHistorico[] | null>(null);
    const [falhou, setFalhou] = useState(false);

    useEffect(() => {
        let ativo = true;
        async function ler() {
            try {
                const resposta = await obterHistorico(pagina);
                if (!ativo) return;
                setItens(resposta.itens);
                setFalhou(false);
            } catch {
                if (ativo) setFalhou(true);
            }
        }
        setItens(null);
        void ler();
        const relogio = window.setInterval(() => {
            if (document.visibilityState === 'visible') void ler();
        }, INTERVALO_MS);
        return () => {
            ativo = false;
            window.clearInterval(relogio);
        };
    }, [pagina]);

    return (
        <aside className="historico-config" aria-labelledby={idDoTitulo}>
            <h3 id={idDoTitulo}>Histórico de alterações</h3>
            {itens === null && !falhou && <p className="nota-config">Carregando…</p>}
            {itens === null && falhou && <p className="nota-config">Não foi possível carregar o histórico.</p>}
            {itens !== null && itens.length === 0 && <p className="nota-config">Nenhuma alteração ainda.</p>}
            {itens !== null && itens.length > 0 && (
                <ul>
                    {itens.map((item) => (
                        <li key={item.id}>
                            <span className="quando-historico">{`${hora(item.ocorrido_em)} · ${item.autor}`}</span>
                            <span className="descricao-historico">{item.descricao}</span>
                        </li>
                    ))}
                </ul>
            )}
        </aside>
    );
}
